// src/complaint.ts
var isComplainable = lineItem => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.mcpFulfillmentLineItemId);
};
var getCauses = () => ({
  // Note: Probably the id is not needed. Not sure if it is used in the application.
  DELIVERY_TOO_LATE: {
    id: "92f9182e-963f-45de-8b4a-ad350302d4ce",
    name: "Delivery to late",
    translationKey: "complaints.causes.deliveryToLate",
    mappedMcpKey: "Delivered too late||Internal Printdeal||"
  },
  NOT_FULLY_DELIVERED: {
    id: "7327742d-0b29-4b81-8c87-f16909e6d824",
    name: "Shipment not delivered or incomplete delivery",
    translationKey: "complaints.causes.notDeliveredOrIncomplete",
    mappedMcpKey: "Shipment not delivered or incomplete delivery||Internal Printdeal||"
  },
  DOES_NOT_MEET_EXPECTATIONS: {
    id: "fb08d29d-5944-4f13-ac0e-860fea0a5b5d",
    name: "Doesn't meet expectations",
    translationKey: "complaints.causes.doesntMeetExpectations",
    mappedMcpKey: "Doesn't meet expectations||Info correct, other expectation||"
  },
  DELIVERED_DAMAGED: {
    id: "92f9182e-963f-45de-8b4a-ad350302d4ce",
    name: "Delivered damaged",
    translationKey: "complaints.causes.deliveredDamaged",
    mappedMcpKey: "Delivered damaged||Internal Printdeal||"
  },
  DAMAGED_PRODUCT: {
    id: "7327742d-0b29-4b81-8c87-f16909e6d824",
    name: "Product damaged after use",
    translationKey: "complaints.causes.productDamaged",
    mappedMcpKey: "Product damaged after use||"
  }
});
var getPreferredResolutions = () => [{
  id: "d0d5c643-cc9b-493d-9ec2-cc97f0553951",
  name: "Reprint",
  translationKey: "complaints.resolutions.reprint",
  mappedMcpKey: "reprint"
}, {
  id: "542ba903-4b41-420f-b90d-068f9cf0a384",
  name: "(partial) refund",
  translationKey: "complaints.resolutions.partialRefund",
  mappedMcpKey: "refund"
}];
var getStatuses = () => [{
  name: "new",
  translationKey: "complaints.status.new",
  mcpComplaintsKey: "new",
  badgeColor: "blue"
}, {
  name: "in progress",
  translationKey: "complaints.status.inProgress",
  mcpComplaintsKey: "inProgress",
  badgeColor: "blue"
}, {
  name: "waiting for customer",
  translationKey: "complaints.status.waitingForCustomer",
  mcpComplaintsKey: "waitingForCustomer",
  badgeColor: "orange"
}, {
  name: "resolved",
  translationKey: "complaints.status.resolved",
  mcpComplaintsKey: "resolved",
  badgeColor: "green"
}, {
  name: "rejected",
  translationKey: "complaints.status.rejected",
  mcpComplaintsKey: "rejected",
  badgeColor: "gray"
}, {
  name: "cancelled",
  translationKey: "complaints.status.cancelled",
  mcpComplaintsKey: "cancelled",
  badgeColor: "gray"
}];
export { isComplainable, getCauses, getPreferredResolutions, getStatuses };